import {createBrowserHistory} from 'history';

let historyInstance = createBrowserHistory();

export const history = historyInstance;

export const HistoryManager = {
    setHistory(newHistory) {
        historyInstance = newHistory;
    },
    getHistory() {
        return historyInstance;
    }
};